import React from 'react';
import { Modal } from '../ui/Modal';
import { Settings, RefreshCw } from 'lucide-react';

const AccessoryDetailsModal = ({ isOpen, onClose, accessory }) => {
    if (!accessory) return null;

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Accessory Details" maxWidth="max-w-xl">
            <div className="space-y-4 p-2">
                {/* MODEL */}
                <div className="flex gap-4">
                    <div className="flex-1">
                        <label className="block text-xs font-bold text-stone-500 uppercase mb-1">MODEL:</label>
                        <div className="w-full bg-stone-950 border border-stone-800 rounded px-3 py-2 text-stone-300">
                            {accessory.model_name}
                        </div>
                    </div>
                    <div className="flex items-end mb-1">
                        <div className="flex items-center gap-2 bg-stone-900 border border-stone-700 rounded px-3 py-2">
                            <input
                                type="checkbox"
                                checked={!!accessory.is_accessory}
                                readOnly
                                className="accent-stone-500 w-4 h-4"
                            />
                            <span className="text-sm text-stone-400">Accessory</span>
                        </div>
                    </div>
                </div>

                {/* SKU */}
                <div>
                    <label className="block text-xs font-bold text-stone-500 uppercase mb-1">SKU*:</label>
                    <div className="w-full bg-stone-950 border border-stone-800 rounded px-3 py-2 text-stone-300">
                        {accessory.sku}
                    </div>
                </div>

                {/* EAN */}
                <div>
                    <label className="block text-xs font-bold text-stone-500 uppercase mb-1">EAN (GTIN):</label>
                    <div className="w-full bg-stone-950 border border-stone-800 rounded px-3 py-2 text-stone-300">
                        {accessory.ean || ''}
                    </div>
                </div>

                {/* COLOR */}
                <div>
                    <label className="block text-xs font-bold text-stone-500 uppercase mb-1">COLOR:</label>
                    <div className="flex gap-2">
                        <div className="flex-1 bg-stone-950 border border-stone-800 rounded px-3 py-2 text-stone-300">
                            {accessory.color || ''}
                        </div>
                        <button className="text-stone-600" disabled><Settings size={18} /></button>
                    </div>
                </div>

                {/* CATEGORY */}
                <div>
                    <label className="block text-xs font-bold text-stone-500 uppercase mb-1">CATEGORY:</label>
                    <div className="flex gap-2">
                        <div className="flex-1 bg-stone-950 border border-stone-800 rounded px-3 py-2 text-stone-300">
                            {accessory.category || ''}
                        </div>
                        <button className="text-stone-600" disabled><Settings size={18} /></button>
                    </div>
                </div>

                {/* STATUS */}
                <div>
                    <label className="block text-xs font-bold text-stone-500 uppercase mb-1">STATUS:</label>
                    <div className="flex gap-2">
                        <div className="flex-1 bg-stone-950 border border-blue-500/50 rounded px-3 py-2 text-stone-300">
                            {accessory.status || ''}
                        </div>
                        <button className="text-stone-600" disabled><Settings size={18} /></button>
                    </div>
                </div>

                {/* STOCK LEVEL */}
                <div>
                    <label className="block text-xs font-bold text-stone-500 uppercase mb-1">STOCK LEVEL:</label>
                    <div className="flex gap-2">
                        <div className="flex-1 bg-stone-950 border border-stone-800 rounded px-3 py-2 text-stone-300">
                            {accessory.stock || 0}
                        </div>
                        <button className="text-stone-600" disabled><RefreshCw size={18} /></button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AccessoryDetailsModal;
